import {
	fetchSettingsQuery,
	logger,
	useAxiosInstance,
	usePoQueries,
} from '@gov-nx/api';

const SETTING_NOTIFICATION_QUERY_KEY = 'setting-notifications';
const NU_EMAIL_QUERY_KEY = 'NU_EMAIL';
const NU_PHONE_QUERY_KEY = 'NU_TELEFON';

export const getNuContactQueryKeys = () => [
	[SETTING_NOTIFICATION_QUERY_KEY, NU_EMAIL_QUERY_KEY],
	[SETTING_NOTIFICATION_QUERY_KEY, NU_PHONE_QUERY_KEY],
];

interface UseNuContactQueriesProps {
	isNuDataEnabled: boolean;
}

export const useNuContactQueries = ({
	isNuDataEnabled,
}: UseNuContactQueriesProps) => {
	const { axiosInstance } = useAxiosInstance();

	const [nuEmailQuery, nuPhoneQuery] = usePoQueries({
		queries: [NU_EMAIL_QUERY_KEY, NU_PHONE_QUERY_KEY].map((key) => ({
			queryKey: [SETTING_NOTIFICATION_QUERY_KEY, key],
			queryFn: () => {
				logger('NastaveniKontaktniUdajeContextProvider', []);
				return fetchSettingsQuery<string>(axiosInstance, key);
			},
			refetchOnWindowFocus: false,
			enabled: isNuDataEnabled,
		})),
	});

	return { nuEmailQuery, nuPhoneQuery };
};
